import React from 'react'

const index = () => {
  return (
    <div>Marketing</div>
  )
}

export default index